import { render, staticRenderFns } from "./ConsumersNewAndRecurrent.vue.vue?vue&type=template&id=525762a5&scoped=true&"
import script from "./ConsumersNewAndRecurrent.vue.vue?vue&type=script&lang=js&"
export * from "./ConsumersNewAndRecurrent.vue.vue?vue&type=script&lang=js&"
import style0 from "./ConsumersNewAndRecurrent.vue.vue?vue&type=style&index=0&id=525762a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525762a5",
  null
  
)

export default component.exports